import { News } from './../../models/News';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'news-list',
  templateUrl: 'news-list.html'
})
export class NewsListComponent {
  @Input('news') news: News[] = [];


  constructor() {

  }
  ngOnInit(){
  }

}



// WEBPACK FOOTER //
// ./src/components/news-list/news-list.ts